// Poreske oznake su ĆIRILIČNE: "А" je U+0410 (ćirilično A), "Ђ" je U+0402.
// Latinično "A" NIJE ista oznaka — u bazi postoji kao usamljena greška u unosu.
export const TAX_LABEL_PDV = "Ђ";
export const TAX_LABEL_NO_PDV = "А";

// CCTalk: fiksno mapiranje kanal -> dinarska vrednost (c001=10 ... c008=2000)
const CCTALK_BY_VALUE = {
  10: "c001",
  20: "c002",
  50: "c003",
  100: "c004",
  200: "c005",
  500: "c006",
  1000: "c007",
  2000: "c008",
};

const VALUE_LADDER = [10, 20, 50, 100, 200, 500, 1000, 2000];
const TOKEN_MULTIPLIERS = [0.5, 1, 2, 5, 10, 20];

const tokenName = (multiplier) => {
  if (multiplier === 0.5) return "1/2 Žetona";
  if (multiplier === 1) return "1 Žeton";
  return `${multiplier} Žetona`;
};

export const MACHINE_TYPES = [
  { key: "zetonjera", label: "Žetonjera" },
  { key: "pranje", label: "Pranje (box)" },
  { key: "usisavanje", label: "Usisavanje" },
];

// Impulsni identifikator: "B" + broj impulsa heksadecimalno (B001=1, B00A=10, B032=50)
const pulseIdentifier = (pulses) =>
  "B" + pulses.toString(16).toUpperCase().padStart(3, "0");

// Generiše stavke šablona. Redove koje izabrani protokol ne može da iskaže
// preskačemo (npr. "1/2 Žetona" kad je vrednost žetona jednaka dinarima po
// impulsu — pola impulsa ne postoji; ili vrednost van CCTalk lestvice).
export const generatePresetItems = ({
  machineType,
  protocol,
  dinPerPulse,
  tokenValue,
}) => {
  const baseRows =
    machineType === "zetonjera"
      ? TOKEN_MULTIPLIERS.map((multiplier) => ({
          name: tokenName(multiplier),
          unitPrice: multiplier * tokenValue,
        }))
      : VALUE_LADDER.map((value) => ({
          name: `${machineType === "pranje" ? "Pranje" : "Usisavanje"} ${value}`,
          unitPrice: value,
        }));

  return baseRows
    .map((row) => {
      if (protocol === "cctalk") {
        const identifier = CCTALK_BY_VALUE[row.unitPrice];
        return identifier ? { ...row, identifier } : null;
      }
      const pulses = row.unitPrice / dinPerPulse;
      if (!Number.isInteger(pulses) || pulses < 1 || pulses > 0xfff) {
        return null;
      }
      return { ...row, identifier: pulseIdentifier(pulses) };
    })
    .filter(Boolean);
};
